import * as R from 'ramda';
import { parse, stringify } from 'query-string';

export const renameKeys = R.curry((keysMap, obj) =>
  R.reduce(
    (acc, key) => {
      const mappedKey = keysMap[key] || key;

      if (Array.isArray(mappedKey)) {
        return R.pipe(
          R.assoc(mappedKey[0], R.path([key, 0], obj)),
          R.assoc(mappedKey[1], R.path([key, 1], obj)),
        )(acc);
      }

      return R.assoc(mappedKey, obj[key], acc);
    },
    {},
    R.keys(obj),
  ),
);

export const extendUrlParams = newParams =>
  stringify({ ...parse(window.location.search), ...newParams });

export const omitUrlParams = params => {
  const allParams = parse(window.location.search);
  const filteredParams = {};

  Object.entries(allParams).forEach(([key, value]) => {
    if (params.indexOf(key) !== -1) {
      return;
    }

    filteredParams[key] = value;
  });

  return stringify(filteredParams);
};



// WEBPACK FOOTER //
// /app/apps/ms/src/helpers/utils.js